module.exports = __webpack_public_path__ + "media/react/gre/organisms/checkpoints/assets/celebration_astronaut-1137f715f884854fe9aacaff7dd3b83d.svg";